/**
 * THIS FILE IS AUTO-GENERATED - DO NOT EDIT MANUALLY
 *
 * Generated by: scripts/generate-icons/extract-and-inline.mjs
 * Source: @central-icons-react v1.1.137
 *
 * @generated
 */

import { memo } from 'react'

import { cn } from '#lib/cn'

import { type IconProps, IconSize, iconSizeValues } from '../types'

export const IconArrowOutOfBox = memo(function IconArrowOutOfBox({
  size = IconSize.Medium,
  title,
  className,
  ref,
  ...props
}: IconProps) {
  return (
    <svg
      width={`${iconSizeValues[size]}px`}
      height={`${iconSizeValues[size]}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!title}
      aria-label={title}
      className={cn('shrink-0', className)}
      ref={ref}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M12 3.75V15M12 3.75L16.5 8.25M12 3.75L7.5 8.25M20.25 14.75V19.25C20.25 19.8023 19.8023 20.25 19.25 20.25H4.75C4.19772 20.25 3.75 19.8023 3.75 19.25V14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})
